<template>
  <div class="taxas">
    <div class="grid-box">
      <Breadcrumb :levels="breadcrumbLevels" />

      <div class="main-block footer">
        <v-layout row wrap>
          <v-flex xs12>
            <div class="boxapp">
              <div class="boxapp-head">
                <a href="#" @click="$router.go(-1)">
                  <faIcon type="fal" name="long-arrow-left" size="24" colorFont="#cfd2dd" />
                </a>
                <h1>Edição de Taxas</h1>
              </div>
              <TaxForm ref="taxesForm" :initialAsaas="asaas" :initialPagarme="pagarme" :initialItau="itau" />
              <div class="footer-step mt-4">
                <v-layout row>
                  <v-spacer></v-spacer>
                  <v-btn flat round color="white" class="btn-primary flex-inherit px-5" large @click="handleSubmit">
                    Salvar
                  </v-btn>
                </v-layout>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import HeroInner from "@/components/HeroInner.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Tax from "@/scripts/models/tax.model.js";
import PaymentMethodProvider from "@/scripts/models/enums/paymentMethodProvider.enum";
import TaxService from "@/scripts/services/tax.service";
import TaxForm from "@/components/TaxForm.vue";

export default {
  components: {
    HeroInner,
    Breadcrumb,
    TaxForm,
  },
  data: () => ({
    breadcrumbLevels: [{ text: "Início" }, { text: "Configurações" }],
    asaas: new Tax(null, PaymentMethodProvider.Asaas, true),
    pagarme: new Tax(null, PaymentMethodProvider.PagarMe, true),
    itau: new Tax(null, PaymentMethodProvider.Itau, true),
    taxService: new TaxService(),
  }),
  created() {
    this.configureTaxes();
    this.loadTaxes();
  },
  methods: {
    loadTaxes() {
      this.taxService.getDefault().then((response) => {
        if (!response || response.length === 0)
          return;

        if (response?.asaas) this.asaas = response.asaas;
        if (response?.pagarMe) this.pagarme = response.pagarMe;
        if (response?.itau) this.itau = response.itau;

      });
    },
    configureTaxes() {
      this.itau.parcelamentsD2 = [];
      this.itau.parcelamentsD30 = [];
    },
    async handleSubmit() {
      const formData = this.$refs.taxesForm.getFormData();
      const { asaas, pagarme, itau } = formData;

      const request = [
        this.taxService.save(asaas),
        this.taxService.save(pagarme),
        this.taxService.save(itau),
      ];
      const [asaasResult, pagarmeResult, itauResult] = await Promise.all(request);

      this.asaas = asaasResult;
      this.pagarme = pagarmeResult;
      this.itau = itauResult;
    },
  },
};
</script>
